import React from 'react';
import KPICard from './KPICard';

const KPISection = ({ data }) => {
  if (!data) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="bg-white rounded-xl shadow-lg p-6 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-8 bg-gray-200 rounded w-1/2"></div>
          </div>
        ))}
      </div>
    );
  }

  const { sales, invoices, credits, revenue } = data;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {/* Invoices Raised */}
      <KPICard
        title="Current Month Invoices Raised"
        value={invoices?.currentMonth || 0}
        change={invoices?.currentMonth && invoices?.previousMonth ? 
          invoices.currentMonth - invoices.previousMonth : undefined}
        color="purple"
        reportLink="/reports/sales-analysis?type=invoice-summary"
        icon={
          <svg className="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        }
      />

      {/* Credits Raised */}
      <KPICard
        title="Current Month Credits Raised"
        value={Math.round(credits?.currentMonth || 0)}
        change={credits?.currentMonth && credits?.previousMonth ? 
          Math.round(credits.currentMonth - credits.previousMonth) : undefined}
        color="red"
        reportLink="/reports/sales-analysis?type=invoice-summary"
        icon={
          <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        }
      />

      {/* Current Month Nett Sales */}
      <KPICard
        title="Current Month Nett Sales"
        value={sales?.netSales || sales?.monthToDate || 0}
        subtitle={`Invoices less Credits`}
        color="blue"
        reportLink="/reports/sales-analysis?type=invoice-summary"
        icon={
          <div className="w-5 h-5 text-blue-600 font-bold text-lg">£</div>
        }
      />

      {/* Revenue & Margin */}
      <KPICard
        title="Total Revenue & Margin"
        value={revenue?.total || 0}
        marginValue={revenue?.margin || 0}
        marginPercent={revenue?.marginPercent || 0}
        color="green"
        reportLink="/reports/branch"
        icon={
          <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        }
      />
    </div>
  );
};

export default KPISection;